<template>
    <div>
        <div id="top" class="h66">
            <div class="pa20 l">
                <div id="logo" width="98" height="40"></div>
            </div>
            
        </div>
        <div id="register">
            <div class="w750 ft16">
                <h1 class="mt50 f20 cff2104 tal">用户注册</h1>
                <ul class="mt20">
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">邮箱：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="email" type="text" placeholder="请输入邮箱" @blur="checkemail"/></div>
                    <div class="l f14 ml10 h36"> <span class="cf06000"> * </span></div>
                    <div class="l f14 ml10 h36"> <label id="email_tishi">推荐使用QQ邮箱</label></div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar">密码：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="password1" type="password" placeholder="请输入密码" @blur="checkpwd1" maxlength="16"/></div>
                    <div class="l f14 ml10 h36"> <span class="cf06000"> * </span></div>
                    <div class="l f14 ml10 h36"> <label id="password1_tishi">密码长度为6-12位的数字和字母</label></div>
                </li> 
                <li  class="mb30 yz">
                    <div class="l w100 h36 tar">确定密码：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="password2" type="password" placeholder="请确定密码" @blur="checkpwd2" maxlength="16"/></div>
                    <div class="l f14 ml10 h36"><span class="cf06000"> * </span></div>
                    <div class="l f14 ml10 h36"><label id="password2_tishi">前后2次密码需要输入一致</label></div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar">手机号码：</div>
                    <div class="l h36"><input  class="h36 w340 plr15 f14 tal  br2" v-model="mobile" type="text" placeholder="请输正确手机号码" @blur="checkmobile" maxlength="11"/></div>
                    <div class="l f14 ml10 h36"> <span class="cf06000">  </span> <label id="mobile_tishi">长度11位，本平台不从手机扣费</label></div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar">验证码：</div>
                    <div class="l h36"><input  class="h36 w248 plr15 f14 tal  br2" v-model="loginCode" type="text" placeholder="请输验证码" /></div>
                    <div class="l ml10 f14 h36">
                        <div class="code" @click="refreshCode">
                            <s-identify :identifyCode="identifyCode"></s-identify>
                        </div>
                    </div>
                </li>
                <li  class=" yz">
                    <div class="l w100 h36 tar"></div>
                    <div class="l h36"><input class="fx1" v-model="boxcheck"  type="checkbox"/></div>
                    <div class="l f14 h36">我已阅读并同意<a href="http://www.yanzhengma.cn/user_2office" target="_bank">《云验证平台协议》</a></div>
                </li>
                    <li  class="mb30 yz">
                    <div class="l w100 h36 tar"></div>
                    <div class="l h36"> <button id="regBtn" class="h36 w280  plr15 f18 dlan" @click="reguser" style="cursor:pointer;">立即注册</button></div>
                </li>
                </ul>
            </div>
        </div>
        <!--弹出层-->
	    
        <div v-show="isShow" style="margin: 0px; padding: 0px; border: none; width: 100%; height: 100%; background: rgb(51, 51, 51); opacity: 0.6; z-index: 9999; position: fixed; top: 0px; left: 0px; display: block;">
            
        </div>
        <div v-show="isShow"  style="margin: -140px 0px 0px -280px; padding: 0px; border: none; z-index: 10000; position: fixed; top: 50%; left: 50%; display: block;">
            <div class="pt30 pop bfff w500" >
                <div class="w500 h20 "><a class="r" href="#" @click="closediv"><img src="../../assets/images/ff.png" width="20" height="20" border="0"/></a></div>
                <div class="w500 h20 "></div>
                <div class="w500 h120" style="width:410px;height:80px;">
                <ul>
                    <li class="hl40 w100 l" style="width:360px;">注册成功！</li>
                    <li class="hl40 w100 l" style="width:360px;">您的门牌号为 : <label style="color:red;">{{useraccount}}</label>，邮箱为：<label style="color:red;">{{email}}</label></li>
                    <li class="hl40 w400 l" style="width:360px;">请用门牌号/手机号/邮箱账号登录。</li>
                    <li class="hl40 w400 l" style="width:360px;color:red;">系统默认开通总机最低消费，每天最低消费0.2元，可在账户设置下的业务订购里修改</li>
                </ul>
                </div>
                <div class="mt20 h40"><button @click="sureBtn" class="h40 w100 r plr15 f18 dlan" style="cursor:pointer;">确定</button></div>	
                
            </div>
        </div>
    </div>
</template>
<script>
import '../../assets/css/index.css'; /*引入公共样式*/
 import {is_email,isMobil, is_number} from '../../assets/js/checkFunction.js'
import {setCookie,getCookie} from '../../assets/js/cookie.js'
export default {
    components : {
        
    },
    data() {
        return {
            identifyCodes: "1234567890",
            identifyCode: "",
            email:'',
            password1:'',
            password2:'',
            mobile: '',
            boxcheck: false,
            loginCode:'',
            isShow: false,
            useraccount:'',
            loginId:'',
            orgId:'',
            mobileString:'',
            memberIdstr:'',
        };
    },
    mounted() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
        this.loginId = this.$route.params.loginId == undefined ? "" : this.$route.params.loginId;
        this.orgId = this.$route.params.orgId == undefined ? "" : this.$route.params.orgId;
        this.mobileString = this.$route.params.mobileString == undefined ? "" : this.$route.params.mobileString;
        this.memberIdstr = this.$route.params.memberIdstr == undefined ? "" : this.$route.params.memberIdstr;
    },
    methods: {
        closediv() {
            this.isShow = false;
        },
        sureBtn() {
            this.$router.push('/')
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        checkemail() {
            if(this.email.trim() == ''){
                $("#email_tishi").css("color","red");
	      	    document.getElementById("email_tishi").innerHTML="请填写邮箱地址！";
		  	    return false;
            }
            if(!is_email(this.email.trim()))
            {
                $("#email_tishi").css("color","red");
                document.getElementById("email_tishi").innerHTML="邮箱地址不符合规定！";
                return false;
            }
            let data = {'email':this.email.trim()}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/reg/checkemail.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    document.getElementById("email_tishi").style.color = "green";
                    document.getElementById("email_tishi").innerHTML= "邮箱可以使用！";
                    return true;
                }
                else
                {
                    document.getElementById("email_tishi").style.color = "red";
					document.getElementById("email_tishi").innerHTML= res.data.msg;
					return false;
                }
            })
        },
        checkpwd1() {
            if(this.password1.trim().length <6 || this.password1.trim().length >12)
            {
                document.getElementById("password1_tishi").innerHTML="密码长度应为6-12位！";
                document.getElementById("password1_tishi").style.color = "red";
                return false;
            }
            var jgpattern =/^[A-Za-z0-9]+$/; 
            if(!jgpattern.test(this.password1.trim()))
            { 
                document.getElementById("password1_tishi").innerHTML="密码只能为数字和字母！";
                document.getElementById("password1_tishi").style.color = "red";
                return false; 
            } 
                
            var jgpattern1 =  /[_a-zA-Z]/;
            if(!jgpattern1.test(this.password1.trim()))
            { 
                document.getElementById("password1_tishi").innerHTML="密码中没同时包含字母！";
                document.getElementById("password1_tishi").style.color = "red";
                return false; 
            }
            if(!this.password1.trim().match(/[0-9]/gi))
            { 
                document.getElementById("password1_tishi").innerHTML="密码中没同时包含数字！";
                document.getElementById("password1_tishi").style.color = "red";
                return false;
            }
            document.getElementById("password1_tishi").innerHTML="密码输入正确！";
            document.getElementById("password1_tishi").style.color = "green";
            return true;
        },
        checkpwd2() {
            if(this.password2.length <6 || this.password2.length>12)
            {
                document.getElementById("password2_tishi").innerHTML="密码长度应为6-12位！";
                document.getElementById("password2_tishi").style.color = "red";
                return false;
            }
            var jgpattern =/^[A-Za-z0-9]+$/; 
            if(!jgpattern.test(this.password2))
            { 
                document.getElementById("password2_tishi").innerHTML="密码只能为数字和字母！";
                document.getElementById("password2_tishi").style.color = "red";
                return false; 
            } 
                
            var jgpattern1 =  /[_a-zA-Z]/;
            if(!jgpattern1.test(this.password2))
            { 
                document.getElementById("password2_tishi").innerHTML="密码中没同时包含字母！";
                document.getElementById("password2_tishi").style.color = "red";
                return false; 
            }
            if(!this.password2.match(/[0-9]/gi))
            { 
                document.getElementById("password2_tishi").innerHTML="密码中没同时包含数字！";
                document.getElementById("password2_tishi").style.color = "red";
                return false;
            }
            if(this.password2 != this.password1)
            {
                document.getElementById("password2_tishi").innerHTML="两次输入密码不一致！";
                document.getElementById("password2_tishi").style.color = "red";
                return false;
            }
            document.getElementById("password2_tishi").innerHTML="确认密码正确！";
            document.getElementById("password2_tishi").style.color = "green";
            return true;
        },
        checkmobile() {
            if(this.mobile.trim().length > 10){
                if(!is_number(this.mobile.trim()))
                {
                    $("#mobile_tishi").html("手机号输入必须为数字！");
                    $("#mobile_tishi").css("color","red");
                    return false;
                }
                if(!isMobil(this.mobile.trim())){
                    $("#mobile_tishi").html("手机号不符合规定！");
                    $("#mobile_tishi").css("color","red");
                    $("#mobile").focus();
                    return false;
                }
                let data = {'mobile':this.mobile.trim()}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + '/reg/checkmobile.json',
                    data: data,
                    headers: {
                        'Content-Type': 'application/json; charset=UTF-8'
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        document.getElementById("mobile_tishi").style.color = "green";
                        document.getElementById("mobile_tishi").innerHTML= "手机号可以使用！";
                        return true;
                    }
                    else
                    {
                        document.getElementById("mobile_tishi").style.color = "red";
						document.getElementById("mobile_tishi").innerHTML= res.data.msg;
                        return false;
                    }
                })
            }
        },
        reguser() {
            var that = this;
            if(this.checkpwd1() == false){
                return;
            }
            if(this.checkpwd2() == false){
                return;
            }
            if(this.loginCode == ""){
                alert("请输入验证码")
                return
            }
            if(this.loginCode != this.identifyCode){
                alert("验证码不正确")
                return
            }
            if(this.boxcheck == false){
                alert("阅读并同意《云验证平台协议》必须选中！");
			    return;
            }
            let data = {'email':this.email.trim(),"password":this.password1.trim(),"mobile":this.mobile,"recommend":"","cpid":"20","loginId":this.loginId,"orgId":this.orgId,"mobileString":this.mobileString,"memberIdstr":this.memberIdstr}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/alicrm/alicrmreg.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            }).then(function(res) {
                if('0000000' == res.data.code){
                        that.GLOBAL.token = res.data.token
                        setCookie('2officesessionid',res.data.token,60*60*10)
                        localStorage.setItem("orgId", res.data.orgId);
                        localStorage.setItem("loginId",res.data.loginId);
                        localStorage.setItem("mobileString", res.data.mobileString);
                        localStorage.setItem("memberIdstr", res.data.memberIdstr);
                        location.href = '/main';
                    }
                    else{
                        alert("注册失败!");
                    }
            })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/alicrm/alicrmreg.vue